import config from 'config';

const isProd = config.PARTNERS_ENVIRONMENT === 'production';

const init = (): string => `
  (function (w, d, s, l, i) {
    w[l] = w[l] || [];
    w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
    var f = d.getElementsByTagName(s)[0],
      j = d.createElement(s),
      dl = l != 'dataLayer' ? '&l=' + l : '';
    j.async = true;
    j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;

    if (!d.querySelector(\`script[src="\${j.src}"]\`)) {
      f.parentNode.insertBefore(j, f);
    }
  })(window, document, 'script', 'dataLayer', 'GTM-TD3RJ9F');

  // Add facebook pixel fbq function
  !(function (f, b, e, v, n, t, s) {
    if (f.fbq) return;
    n = f.fbq = function () {
      n.callMethod
        ? n.callMethod.apply(n, arguments)
        : n.queue.push(arguments);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = !0;
    n.version = '2.0';
    n.queue = [];
  })(window);

  window.fbq('init', '1154310586371066');
  window.fbq('track', 'PageView');
`;

export const googleTagManager:
  | React.JSX.IntrinsicElements['script']
  | undefined = isProd
  ? {
      children: init(),
    }
  : undefined;
